import { Component, OnInit, Input } from "@angular/core";
import { McqDirective } from "../../quiz/mcq/mcq.directive";

@Component({
	selector: "app-vector-mcq",
	templateUrl: "./vector-mcq.directive.html",
	styleUrls: ["./vector-mcq.directive.scss"],
})
export class VectorMcqDirective extends McqDirective {
	/*@Input() textDirection:string;
  @Input() textAlign:string;*/
}
